import React from 'react'
import Helmet from 'react-helmet'
import { useSelector } from 'react-redux'
import { IntlProvider } from 'react-intl'
import { detect } from 'detect-browser'
import isMobile from 'is-mobile'

import DesktopTitleBar from './Layout/DesktopTitleBar'
import BrowserNotSupported from 'components/Errors/BrowserNotSupported'
import DeviceNotSupported from 'components/Errors/DeviceNotSupported'

const DEFAULT_LOCALE = 'en'

export default function Document({
  title = 'Slite',
  isPublic = false,
  children,
}) {
  const isBrowserSupported = React.useMemo(() => {
    const browser = detect()
    return !browser || browser.name !== 'ie'
  }, [])

  const isDeviceNotSupported = React.useMemo(
    () => {
      return isMobile({ featureDetect: true, tablet: true }) && !isPublic
    },
    [isPublic]
  )

  const intl = useSelector(state => state.intl)

  if (!isBrowserSupported) {
    return <BrowserNotSupported />
  }
  if (isDeviceNotSupported) {
    return <DeviceNotSupported />
  }

  return (
    <React.Fragment>
      {/* Title bar used to drag Electron window */}
      <DesktopTitleBar />

      <Helmet
        htmlAttributes={{ lang: intl.currentLocale || 'en' }}
        title={title}
        meta={[
          {
            name: 'description',
            content: 'Collaborative doc app that brings you to Uranus',
          },
        ]}
      />
      <IntlProvider
        defaultLocale={intl.defaultLocale || DEFAULT_LOCALE}
        initialNow={intl.initialNow || DEFAULT_LOCALE}
        key={intl.currentLocale} // https://github.com/yahoo/react-intl/issues/23 || DEFAULT_LOCALE4
        locale={intl.currentLocale || DEFAULT_LOCALE}
        messages={intl.messages[intl.currentLocale || DEFAULT_LOCALE]}
      >
        {children}
      </IntlProvider>
    </React.Fragment>
  )
}
